import { Api } from 'models/services/api';
import { UpdateDishCategoryQuery } from 'models/services/graphql';

import { DishCategoryData, DishCategoryDataToUpdate } from '../index';

type DataToUpdate = {
  id: string;
  input: DishCategoryDataToUpdate;
};

const RequestQuery = `
  mutation UpdateDishCategory($id: ID!, $input: DishCategoryUpdateInput!) {
    ${UpdateDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    updateDishCategory: DishCategoryData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: DishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };